import { useQuery } from "@tanstack/react-query";

const useGetVolunteersByTrialId = (trialId) => {
  // console.log("trialCode =>>", trialId);
  const {
    refetch,
    isLoading,
    isError,
    error,
    isSuccess,
    data: getVolunteersByTrialId = [],
  } = useQuery({
    queryKey: ["GetVolunteersByTrialId", trialId],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/get-volu-dtl-by-trial/${trialId}`
      );
      const data = await res.json();
      // console.log("trial volunteer by id ", data.data);
      return data.data;
    },
    enabled: !!trialId,
  });

  return {
    getVolunteersByTrialId,
    isLoading,
    isError,
    error,
    isSuccess,
    refetch,
  };
};

export default useGetVolunteersByTrialId;
